import styles from '@pages/RequirementLaborResources/RequirementLaborResources.module.scss'
import { Tag } from 'antd'
import cl from 'classnames'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { getCurrentLanguage } from '@/i18next'
import { toValue } from '@pages/RequirementLaborResources'
import { LANGUAGE_ENUM as LANG } from '@/shared'
import { AntdTable } from '@/components/AntdTable/AntdTable'

export const CropCultivationTable = memo(({item}) => {
	const { t } = useTranslation()
	const lang = getCurrentLanguage()

	const columnCropCultivation = [
		{
			key: 'stages_of_agricultural_work',
			dataIndex: 'stages_of_agricultural_work',
			title: t('requirement_labor_resources.stages_of_agricultural_work'),
			width: 500,
			render: (text, record, index) => {
				return text || '-'
			}
		},
		{
			key: 'labor_intensity_person_hours',
			dataIndex: 'labor_intensity_person_hours',
			width: 200,
			title: t('requirement_labor_resources.labor_intensity_person_hours'),
			render: (text, record, index) => {
				return toValue(text)
			},
		},
		{
			key: 'optimal_agrotechnical_terms',
			dataIndex: 'optimal_agrotechnical_terms',
			width: 200,
			title: t('requirement_labor_resources.optimal_agrotechnical_terms'),
			render: (text, record, index) => {
				return text || '-'
			},
		},
		{
			key: 'regulated_number_of_workers_persons',
			dataIndex: 'regulated_number_of_workers_persons',
			width: 200,
			title: t('requirement_labor_resources.regulated_number_of_workers_persons'),
			render: (text, record, index) => {
				return text || '-'
			},
		},
	]

	const data = item?.agriculturalCropTypeDtos?.map((crop, cropIdx) => {
		let label = {
			[LANG.kz]: crop.seasonNameKz,
			[LANG.rus]: crop.seasonNameRu,
		}
		const date = crop?.seasonWotkDtos?.find((seasonWotk, seasonWotkIdx) => seasonWotk.startDdmm)
		const headCount = crop?.seasonWotkDtos?.find((seasonWotk, seasonWotkIdx) => seasonWotk?.totalHeadCount)

		const filtered_stages_of_agricultural_work = crop?.rawDataDtos?.filter(rowData => rowData?.rawMaterialRu)
		const sorted = Object.values(
			filtered_stages_of_agricultural_work.reduce((acc, { rawMaterialRu, resourceInput, rawMaterialKz }) => {
				if (!acc[rawMaterialRu] || resourceInput > acc[rawMaterialRu].resourceInput) {
					acc[rawMaterialRu] = { rawMaterialRu, resourceInput, rawMaterialKz }
				}
				return acc
			}, {}),
		)

		return {
			key: cropIdx,
			stages_of_agricultural_work: (
				<div>
					<span>{label[lang] || '-'}</span>

					<div className={styles.tagContainer}>
						{sorted?.map((rawData, rawDataIdx) => {
							let label = {
								[LANG.kz]: rawData.rawMaterialKz,
								[LANG.rus]: rawData.rawMaterialRu,
							}
							return <Tag color="#A5AEBE" key={`Tag-${rawDataIdx}`}
													style={{ borderRadius: 4 }}>{label[lang]}-{toValue(rawData.resourceInput)} тонн</Tag>
						})}
					</div>
				</div>
			),
			labor_intensity_person_hours: crop?.totalWorkLoadBySeason || '-',
			regulated_number_of_workers_persons: headCount?.totalHeadCount || '-',
			optimal_agrotechnical_terms: `${date?.startDdmm || '-'}-${date?.endDdmm || ''}`,
			children: crop?.seasonWotkDtos?.map((seasonWotk, seasonWotkIdx) => {
				let label = {
					[LANG.kz]: seasonWotk.groupWorkKz,
					[LANG.rus]: seasonWotk.groupWorkRu,
				}

				return {
					key: `${cropIdx}-${seasonWotkIdx}`,
					stages_of_agricultural_work: (
						<div className={cl('flex', 'flex-column', 'gap-1')}>
							<span>{label[lang] || '-'}</span>
							<span className={styles.secondary}>{t('requirement_labor_resources.works')}:</span>
						</div>
					),
					labor_intensity_person_hours: seasonWotk?.totalWorkLoad || '-',
					optimal_agrotechnical_terms: `-`,
					regulated_number_of_workers_persons: seasonWotk.totalHeadCount || '-',
					children: seasonWotk?.agriculturalWorkTypes?.map((agriculturalWork, agriculturalWorkIdx) => {
						let label = {
							[LANG.kz]: agriculturalWork.workNameKz,
							[LANG.rus]: agriculturalWork.workNameRu,
						}
						return {
							key: `${cropIdx}-${seasonWotkIdx}-${agriculturalWorkIdx}`,
							stages_of_agricultural_work: label[lang] || '-',
							labor_intensity_person_hours: agriculturalWork.workLoad || '-',
							optimal_agrotechnical_terms: `-`,
							regulated_number_of_workers_persons: seasonWotk.totalHeadCount || '-',
						}
					}),
				}
			}),
		}
	})

	return (
		<div className={styles.table}>
			<AntdTable
				columns={columnCropCultivation}
				dataSource={data}
				pagination={false}
				scroll={{ x: true }}
				expandable={{
					expandRowByClick: true
				}}
			/>
		</div>
	)
})